import React, { forwardRef } from 'react';
import { ButtonStyled as ButtonStyledBase, LoaderWrapper } from './style';

// Cast to accept custom styled-component props (style file is .js, not typed)
const ButtonStyled = ButtonStyledBase as React.ComponentType<any>;
import { ClipLoader } from 'react-spinners';

const override = {
  transform: 'scale(1)'
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: string;
  size?: string;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  withIcon?: boolean;
  maxWidth?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = 'primary',
      size = 'md',
      onClick,
      isLoading = false,
      leftIcon,
      rightIcon,
      withIcon, // destructure to remove from ...props
      type = 'button', // default to button
      ...props
    },
    ref
  ) => {
    return (
      <ButtonStyled
        {...props}
        onClick={onClick}
        variant={variant}
        size={size}
        ref={ref}
        withIcon={!!leftIcon || !!rightIcon}
        type={type}
      >
        {!isLoading && leftIcon}
        {isLoading ? (
          <LoaderWrapper>
            <ClipLoader
              cssOverride={override}
              color={variant.includes('filled') || variant.includes('primary') ? '#fff' : '#228BE6'}
              size={15}
            />
          </LoaderWrapper>
        ) : (
          children
        )}
        {!isLoading && rightIcon}
      </ButtonStyled>
    );
  }
);

Button.displayName = 'Button';

export default Button;
